"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const OneToken_1 = __importDefault(require("./OneToken"));
const OTP_1 = __importDefault(require("./OTP"));
const LostOrChanged_1 = __importDefault(require("./LostOrChanged"));
const Login2FAApproved_1 = __importDefault(require("./Login2FAApproved"));
const CommonPopup_1 = __importDefault(require("@/components/popup/CommonPopup"));
const TokenValidation_1 = __importDefault(require("./TokenValidation"));
const PopupTwoFASigning_1 = __importDefault(require("./PopupTwoFASigning"));
const Login2FA = ({ intl }) => {
    const { layoutStatus, login2faPopupData } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    if (login2faPopupData.show) {
        return (react_1.default.createElement(CommonPopup_1.default, { title: intl.formatMessage({ id: login2faPopupData.titleId }), content: intl.formatMessage({ id: login2faPopupData.contentId }), toggleTopRightCancel: () => login2faPopupData.toggleTopRightCancel(), footerType: login2faPopupData.footerType, leftBtnLabel: login2faPopupData.leftBtnLabelId ? intl.formatMessage({ id: login2faPopupData.leftBtnLabelId }) : '', toggleLeftBtn: () => login2faPopupData.leftBtnCallback(), rightBtnLabel: intl.formatMessage({ id: login2faPopupData.rightBtnLabelId }), toggleRightBtn: () => login2faPopupData.rightBtnCallback() }));
    }
    if (layoutStatus === types_1.LayoutStatus.VERIFY_SUCCESS) {
        return react_1.default.createElement(Login2FAApproved_1.default, { open: true });
    }
    if (layoutStatus === types_1.LayoutStatus.VERIFY_SUCCESS_DISMISS) {
        return null;
    }
    if (layoutStatus === types_1.LayoutStatus.ONE_TOKEN || layoutStatus === types_1.LayoutStatus.ONE_TOKEN_WITH_FOOTER) {
        return react_1.default.createElement(OneToken_1.default, null);
    }
    if (layoutStatus === types_1.LayoutStatus.OTP) {
        return react_1.default.createElement(OTP_1.default, null);
    }
    if (layoutStatus === types_1.LayoutStatus.HARD_WARE_TOKEN) {
        return react_1.default.createElement(PopupTwoFASigning_1.default, null);
    }
    if (layoutStatus === types_1.LayoutStatus.LOST_OR_CHANGED) {
        return react_1.default.createElement(LostOrChanged_1.default, null);
    }
    if (layoutStatus === types_1.LayoutStatus.TOKEN_VALIDATION) {
        // or invalid one token?
        return react_1.default.createElement(TokenValidation_1.default, null);
    }
    return react_1.default.createElement("div", null);
};
exports.default = (0, react_intl_1.injectIntl)(Login2FA);
